export const EDA_BASE_API_URL = process.env.REACT_APP_EDA_BASE_API_URL;

// GET - Retorna lista paginada dos logs dos Dados Laboratoriais de 1ª e 24ª Horas
export const EDA_GET_INTEGRATION_LOG_1H_AND_24H_ENDPOINT = '/integrations/1h-and-24h/logs';

// GET - Retorna lista paginada dos logs da integração de complicações
export const EDA_GET_INTEGRATION_LOG_ACUTE_COMPLICATIONS_ENDPOINT = '/integrations/acute-complications/logs';

// GET - Retorna lista paginada dos logs da integração de admissões
export const EDA_GET_INTEGRATION_LOG_ADMISSIONS_ENDPOINT = '/integrations/admissions/logs';

// GET - Retorna lista paginada dos logs da integração de comorbidades
export const EDA_GET_INTEGRATION_LOG_COMORBIDITIES_ENDPOINT = '/integrations/comorbidities/logs';

// GET - Retorna lista paginada dos logs da integração de diagnósticos
export const EDA_GET_INTEGRATION_LOG_DIAGNOSIS_ENDPOINT = '/integrations/diagnosis/logs';

// GET - Retorna lista paginada dos logs dos Dispositivos Invasivos
export const EDA_GET_INTEGRATION_LOG_INVASIVE_DEVICE_ENDPOINT = '/integrations/invasive-devices/logs';

// GET - Retorna lista paginada dos logs da integração de admissões
export const EDA_GET_INTEGRATION_LOG_LAB_MICRO_ENDPOINT = '/integrations/lab-micro/logs';

// GET - Retorna lista das informações do metodo de integração SAPS3
export const EDA_GET_INTEGRATION_LOG_SAPS3_ENDPOINT = '/integrations/saps3/logs';

// GET
export const EDA_GET_INTEGRATION_LOG_UNIT_RESOURCES_ENDPOINT = '/integrations/unit-resources/logs';

// GET - Retorna os tipos de integrações.
export const EDA_GET_INTEGRATION_TYPES_ENDPOINT = '/integrations/types';

// GET - Retorna os status de integrações.
export const EDA_GET_INTEGRATION_STATUS_ENDPOINT = '/integrations/status';
